import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { v4 as uuidv4 } from 'uuid'
import { useForm } from 'react-hook-form'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { WarningModal } from 'components/Modals/WarningModal'
import NotificationActions from 'actions/Notification'
import { useDispatch, useSelector } from 'react-redux'
import NotificationService from 'services/Notification'
import { useCallbackPrompt } from 'hooks/useCallbackPrompt'
import { Beforeunload } from 'react-beforeunload'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { BackButton, ContainerForm, MainForm, Top, TopInputs, SaveButton, TitleForm, SubtitleForm } from './styles'
import { Breadcrumbs, SecondTextBreadcrumbs } from '../Header/styles'
import { ActionsComponent } from './Children/ActionsComponent'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import { notificationStatus } from 'constants/notificationStatus'
import { NotificationAction, NotificationReducer } from 'types/notification'
import { Dispatch } from 'redux'
import { NotificationDetalhes } from 'pages/Notifications/LeftSideV2'
import { hasEmptyValue } from 'utils/objectEmptyValue'

export const ActionForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const notificationDispatch: Dispatch<NotificationAction> = useDispatch<Dispatch<NotificationAction>>()

  const [canSave, setCanSave] = useState(false)
  const [statusIsArchivedOrFinished, setStatusIsArchivedOrFinished] = useState(false)
  const [notificationStatusState, setNotificationStatusState] = useState('')
  const [isSaving, setIsSaving] = useState(false)

  const {
    trigger,
    register,
    control,
    formState: { isDirty, dirtyFields, errors ,},
    getValues,
    reset,
    watch,
    unregister,
    setValue,
    resetField,
    handleSubmit,
  } = useForm({
    defaultValues: {
      fields: [
        {
          sys_id: "",
          id: uuidv4(),
          how: "",
          what: "",
          when: "",
          where: "",
          who: "",
          why: "",
          how_much: "R$ 0,00"
        }
      ]
    }
  })
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(isDirty && !isSaving)

  const watchedData = watch();
  const auth: IAuthenticationReducer = useSelector(
    (state: RootReducerState) => state.authenticationReducers
  )
  const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)

  useEffect(() => {
    if (notificationSelector?.notificationById?.u_state) {
      setNotificationStatusState(
        notificationSelector?.notificationById?.u_state.display_value
      )
    }
  }, [notificationSelector.notificationById])
  useEffect(() => {
    if (notificationStatusState) {
      const allowed = [notificationStatus[4].label, notificationStatus[5].label]
      const satus = allowed.includes(notificationStatusState)
      setStatusIsArchivedOrFinished(satus)
    }
  }, [notificationStatusState])


  useEffect(() => {
    if (!notificationSelector?.notificationById) {
      NotificationActions.getNotificationById(notificationDispatch, id)
    }
  }, [id, notificationDispatch])
  const currentUser = useMemo(() => {
    return auth.dataJwt
  }, [auth])

  const actionPlans = useMemo(
    () => notificationSelector.actionPlans,
    [notificationSelector.actionPlans]
  )

  const backToLondonAction = useCallback((e: any) => {
    navigate(`/notificacoes/${id}`, { state: { currentStep: 5 } })
  }, [])


  useEffect(() => {
    if (!isDirty) {
      setCanSave(false)
    } else {
      const watchedFields = watchedData.fields
      let allFieldsNonEmpty = true;
  
      for (const key in watchedFields) {
        const action = watchedFields[key]
        const when =action.when
        var regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
        const isValidDate = regex.test(when)
        const doesHaveEmpty = hasEmptyValue(action, ["sys_id"])
        if (doesHaveEmpty || !isValidDate) {
          allFieldsNonEmpty = false;
          break;
        }
      }
      setCanSave(allFieldsNonEmpty)
    }
   
  }, [watchedData])
  const saveStep4Handler = async () => {
    setIsSaving(true)
    const doesNotHaveError = await trigger()
    if (!doesNotHaveError) {
      setIsSaving(false)
      return
    }

    try {
      const dirtyIndices = dirtyFields.fields?.map((item, index) => index) || []
      const forumValues = getValues()

      // Separar planos para criar e para atualizar
      const plansToCreate = []
      const plansToUpdate = []

      for (const [index, row] of forumValues?.fields.entries()) {
        const formattedRow = {
          hospital_incident: id,
          how: row.how,
          how_much: row.how_much,
          what: row.what,
          when: row.when,
          where: row.where,
          who: row.who,
          why: row.why,
          u_notifica_user: currentUser?.sys_id || '',
          u_do_not_perform_optional: 'false'
        }

        if (!row.sys_id) {
          // Novo plano para criar
          plansToCreate.push(formattedRow)
        } else if (dirtyIndices.includes(index)) {
          // Plano existente para atualizar
          plansToUpdate.push({
            sys_id: row.sys_id,
            ...formattedRow
          })
        }
      }

      // Executar operações batch
      if (plansToCreate.length > 0) {
        const createBatchRequest = {
          records: plansToCreate,
          options: {
            stopOnError: false
          }
        }
        await NotificationActions.createActionPlanBatch(notificationDispatch, createBatchRequest)
      }

      if (plansToUpdate.length > 0) {
        const updateBatchRequest = {
          records: plansToUpdate,
          options: {
            stopOnError: false
          }
        }
        await NotificationActions.updateActionPlanBatch(notificationDispatch, updateBatchRequest)
      }

      // Recarregar dados
      NotificationActions.getListOfActionPlan(
        notificationDispatch,
        id
      )

      navigate(`/notificacoes/${id}`, { state: { currentStep: 5, messageSuccess: 'Plano de ação salvo com sucesso!' } })
    } catch (error) {
      console.error('Erro ao salvar plano de ação:', error)
    } finally {
      setIsSaving(false)
    }
  }
  return (
    <>
      {isDirty && (
        <Beforeunload onBeforeunload={(event) => 'Você fez edições que não forma salvas.'} />
      )}
      <WarningModal
        icon={
          <AiOutlineExclamationCircle
            size={50}
            className="text-yellow"
          />
        }
        customStyle={{
          titleStyle: 'text-yellow'
        }}
        title="Edição não salva"
        subTitle="Você fez edições que não foram salvas. Se sair, você perderá as edições."
        leftButtonAction={confirmNavigation as () => void}
        rightButtonAction={cancelNavigation as () => void}
        isOpen={showPrompt as boolean}
        handleCloseModal={cancelNavigation as () => void}
        leftButtonText="Sair"
        rightButtonText="Continuar edição"
      />

      <ContainerForm data-testid="test-step4-from">
        <MainForm onSubmit={handleSubmit(saveStep4Handler)}>
          <div className='flex items-baseline mt-8 justify-between'>
            <Breadcrumbs>
              <Link className="mr-1 cursor-pointer" to="/notificacoes">
                Gestão das notificações
              </Link>
              {' > '}
              <SecondTextBreadcrumbs className="mr-1 cursor-pointer" onClick={backToLondonAction}>
                Notificações
              </SecondTextBreadcrumbs>
              {' > '}
              <SecondTextBreadcrumbs>Plano de ação</SecondTextBreadcrumbs>
            </Breadcrumbs>
            <TopInputs>
              <BackButton type='button' onClick={backToLondonAction}>Voltar</BackButton>
              <SaveButton type='submit' disabled={!canSave} className={!canSave ? 'bg-disabled' : ''}>Salvar</SaveButton>
            </TopInputs>
          </div>
          <div className='overflow-y-auto'>
            <Top>
              <div>
                <TitleForm data-testid='notifications'>Editar Plano de ação</TitleForm>
                <SubtitleForm>Descreva quais os planos de ação do seu setor para a resolução de incidentes desse tipo.</SubtitleForm>
              </div>


            </Top>
            <div className="grid grid-cols-6  px-8 mt-6 gap-10">
              <div className="col-span-6 xl:col-span-4 ">
                <ActionsComponent
                  id={id}
                  trigger={trigger}
                  tooltipAlert={''}
                  register={register}
                  control={control}
                  reset={reset}
                  getValues={getValues}
                  watch={watch}
                  errors={errors}
                  currentUser={currentUser}
                  dirtyFieldsStep4={dirtyFields}
                  setValue={setValue}
                  resetField={resetField}
                  isDirty={isDirty}
                  statusIsArchivedOrFinished={statusIsArchivedOrFinished}
                  actionPlans={actionPlans}
                  notificationById={notificationSelector?.notificationById}
                  notificationStatusState={notificationStatusState}
                />
              </div>
              <div className="col-span-6 xl:col-span-2 bg-greyWhite rounded-lg">
                {
                  notificationSelector?.notificationById ?
                    <NotificationDetalhes
                      isShowAnalyze={false}
                      currentNotificationSelected={notificationSelector?.notificationById}
                      notificationAnalizer={() => { }}
                    /> : null
                }
              </div>
            </div>
          </div>
        </MainForm>
      </ContainerForm>
    </>
  )
}
